export const GIF_URL =
    'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/96878bde277e8918068cd861a4a14718-1748615431941/03_Loading';
export const IMAGE_URL =
    'https://d26viwmjswwe40.cloudfront.net/BYS_prod/Default/Fashion%20%26%20Apparel/banner1_small.jpg';
export const SHOPIFY_URL = 'https://admin.shopify.com/store/<shopify_store_name>/themes';
